import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { HomeHeader, HomeFooter } from './Home';
import { initializeHome } from '../components/homeEffects';
import '../assets/home.css';

export default function NotFound() {
  const pageRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const previousTitle = document.title;
    document.title = 'Page not found — Shiwani';
    const cleanup = initializeHome(pageRef.current);
    return () => {
      document.title = previousTitle;
      if (cleanup) cleanup();
    };
  }, []);

  return (
    <div className="home-redesign page not-found" ref={pageRef}>
      <div className="field" aria-hidden="true"><canvas /></div>
      <HomeHeader />
      <main className="wrap hero not-found__main" aria-labelledby="not-found-title">
        <p className="mono not-found__status in-1"><span aria-hidden="true" />404 — Page not found</p>
        <h1 className="headline in-1" id="not-found-title">A little off <em>course.</em></h1>
        <div className="hero__foot in-2">
          <div className="intro">
            <p className="lede">This page may have moved, or the link took a wrong turn. Let’s get you back to the work.</p>
            <div className="links not-found__actions">
              <Link className="link" to="/">
                <span className="link__label">Back to home</span>
                <span className="not-found__arrow" aria-hidden="true">↗</span>
              </Link>
            </div>
          </div>
        </div>
        <span className="not-found__number" aria-hidden="true">404</span>
      </main>
      <HomeFooter />
    </div>
  );
}
